import { render, staticRenderFns } from "./LoginFlow.vue?vue&type=template&id=7863b50a&scoped=true"
import script from "./LoginFlow.vue?vue&type=script&lang=js"
export * from "./LoginFlow.vue?vue&type=script&lang=js"
import style0 from "./LoginFlow.vue?vue&type=style&index=0&id=7863b50a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7863b50a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7863b50a')) {
      api.createRecord('7863b50a', component.options)
    } else {
      api.reload('7863b50a', component.options)
    }
    module.hot.accept("./LoginFlow.vue?vue&type=template&id=7863b50a&scoped=true", function () {
      api.rerender('7863b50a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/LoginFlow.vue"
export default component.exports